<template>
  <div class="home">
    <banner-Component></banner-Component>
   <div class="main">
<!--    关于我们-->
       <div class="about">
        <div class="title">
            <p class="wow fadeInUp">brand introduction</p>
            <p class="wow fadeInUp">品牌介绍</p>
        </div>
           <div class="content">
           <div class="left wow fadeInLeft">
           <div class="t1">
               <p>浙江延宝科技（集团）有限公司</p>
               <p>Zhejiang Yanbao Car Butler Technology Co., Ltd.</p>
           </div>
               <div class="nr">
                 是一家多元化与专业化相结合、以现代服务业为主导的大型企业集团，集团总部位于宁波市镇海区。自2015年成立以来，集团以改变车主用车方式为定位，深入挖掘汽车后市场，业务遍布全国27个省市及海外市场。集团在延保销售、延保TPA、平行出口及二手车出口业务、汽车金融、24小时无接触洗车机、干冰清洗机等汽车板块不断深化拓展，打造高品质的服务产业。
               </div>
           </div>
               <div class="right wow fadeInRight">
                 <p>始创于</p>
                   <p>2015</p>
                   <p>年</p>
                   <div></div>
               </div>
           </div>

           <div class="ln">
             <div class="p1">
                 <p class="wow fadeInUp">倡导企业全生命周期绿色发展的理念</p>
                 <p class="wow fadeInUp">Advocate The Concept Of Green Development In The Whole Life Cycle Of The Enterprise</p>
             </div>
               <div class="allItems wow fadeInUp">
                 <div class="item" v-for="(item,index) in list" :key="index" >
                     <div>
                         <img :src="item.img" alt="">
                     </div>
                     <p>{{item.title}}</p>
                 </div>
               </div>
               <div class="btn wow fadeInUp">
                   <a href="/about.html" target="_self">探索更多精彩</a>
               </div>
           </div>
       </div>

<!--       产品中心-->
       <mpro class="wow fadeIn" />

<!--       新闻中心-->
       <news />

<!--       <customer class="wow fadeIn" />-->
   </div>
      <foot-Component class="foot wow fadeIn" ></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import Scrollbar from 'smooth-scrollbar'
  import { CountUp } from 'countup.js'
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import footComponent from '../components/foot'
  import mpro from '../components/mpro'
  import news from '../components/news'
  import customer from '../components/customer'
export default {
  name: 'home',
    data(){
      return{
          list:[
              {
                  img:require('../assets/ycb/jsyf.png'),
                  title:'技术研发'
              },
              {
                  img:require('../assets/ycb/qygl.png'),
                  title:'企业管理'
              },
              {
                  img:require('../assets/ycb/fxgk.png'),
                  title:'风险管控'
              },
              {
                  img:require('../assets/ycb/scyx.png'),
                  title:'市场营销'
              },
              {
                  img:require('../assets/ycb/shfw.png'),
                  title:'售后服务'
              }
          ],
          scrollbar:'',
          pList:[],
          nList:[],
          swiperOption:{
              slidesPerView: 4,
              speed:1000,
              spaceBetween : 20,
              navigation: {
                  nextEl: '.allImgs .next',
                  prevEl: '.allImgs .prev'
              }
          },
          swiperOption2:{
              slidesPerView: 1,
              speed:1000,
              navigation: {
                  nextEl: '.allImgs .next',
                  prevEl: '.allImgs .prev'
              }
          },
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,1)
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener((status) => {
            window.pageYOffset=this.scrollbar.scrollTop
        });
        // setTimeout(()=>{
        //     this.count()
        // },100)
    },
  components:{bannerComponent,footComponent,swiper, swiperSlide,mpro,news,customer},
    methods:{
        gotoInfo(n){
            const link=`/newsInfo.html?id=${n}`
            window.open(link,'_blank')
        },
        getNews(id){
            const url = `${getNewsUrl('zh-CN',id,1000,1)}`
            this.$axios.get(url).then(res => {
                res.data.newsArr.map((item)=>{
                    item.SHOWTIME=item.SHOWTIME.slice(0,11)
                    if(item.ISCOMMEND==='1'){
                        this.nList.push(item)
                    }
                })
            })
        },
        count(){
            let element=this.$refs.counts;
            let actualTop = element.offsetTop;
            let current = element.offsetParent;
            while (element=element.offsetParent){
                actualTop += element.offsetTop;
                /* current = current.offsetParent; */
            }
            let demoFi1 = new CountUp("num1", 1500);
            let demoFi2 = new CountUp("num2", 7500);
            let demoFi3 = new CountUp("num3", 200);
            // demoFi1.start();
            // demoFi2.start();
            // demoFi3.start();
            let numok=false;
            let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
            if(scrollbar){
                scrollbar.addListener((status) => {
                    if(!numok){
                        if(actualTop<status.offset.y+document.body.clientHeight){
                            demoFi1.start();
                            demoFi2.start();
                            demoFi3.start();
                            numok=true;
                        }
                    }
                });
            }
        },
        gotoAbout(){
            const link='/about.html'
            window.open(link,'_self')
        },
        gotoNews(){
            const link='/news.html'
            window.open(link,'_self')
        },
     change(n){
       this.select=n
     }
    }
}
</script>

<style lang="scss" scoped>
.home{
  width:100%;
    animation: run5 1s linear forwards;
    @keyframes run5 {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }
  .main{
    width:100%;
     .about{
         width:100%;
         margin: 60px auto;
         animation-duration: 3s;
         .title{
             width:100%;
             p{
                 text-align: center;
             }
             p:nth-child(1){
                 font-family: "DINEngschriftStd";
                 color:#286AA0;
                 font-size: 40px;
                 text-transform: uppercase;
             }
             p:nth-child(2){
                 font-family: "SourceHanSansSC-Normal.otf";
                 margin-top: 10px;
             }
         }
         .content{
             width:1440px;
             display: flex;
             flex-direction: row;
             justify-content: space-between;
             margin: 80px auto;
             .left{
                 width:60%;
                 .t1{
                     p:nth-child(1){
                         color:#286AA0;
                         font-size: 28px;
                         font-family: "SourceHanSansSC-Medium";
                     }
                     p:nth-child(2){
                         color:#999999;
                         font-family: "it";
                         margin-top: 10px;
                     }
                 }
                 .nr{
                     width:100%;
                     margin-top: 30px;
                     font-size: 14px;
                     line-height: 35px;
                     color:#000500;
                     font-family: "SOURCEHANSANSCN-LIGHT";
                 }
             }
             .right{
                 width:30%;
                 position: absolute;
                 right:0;
                 p{
                     text-align: center;
                     font-family: "SOURCEHANSANSCN-LIGHT";
                     margin-top: 20px;
                 }
                 p:nth-child(2){
                     color:#F47238;
                     font-size: 50px;
                     font-family: "DINEngschriftStd";
                     margin: 5px auto;
                 }
                 div{
                     width:15px;
                     height:3px;
                     background:rgba(0,0,0,1);
                     margin: 10px auto;
                     margin-bottom: 0;
                 }
                 &::after{
                     content:'';
                     display: inline-block;
                     width:100%;
                     height:1px;
                     position: absolute;
                     right:-30%;
                     bottom:0;
                     background:rgba(239,239,239,1);
                 }
             }
         }
         .ln{
             width:1440px;
             margin: 30px auto;
             .p1{
                 width:100%;
                 p{
                     text-align: center;
                 }
                 p:nth-child(1){
                     font-family: "SourceHanSansSC-Regular.otf";
                     font-size: 20px;
                 }
                 p:nth-child(2){
                     font-family: "it";
                     color:#999999;
                     font-size: 14px;
                     margin-top: 10px;
                 }
             }
             .allItems{
                 width:100%;
                 display: flex;
                 flex-direction: row;
                justify-content: center;
                 margin: 60px auto;
                 .item{
                     width:15%;
                     cursor: pointer;
                     div{
                         width:100%;
                         overflow: hidden;
                         text-align: center;
                         transition: all 600ms;
                     }
                     p{
                         text-align: center;
                         color:#000500;
                         font-family: "SourceHanSansSC-Normal.otf";
                         margin: 10px auto;
                         transition: all 600ms;
                     }
                     &:hover{
                         div{
                             transform: rotateY(360deg);
                         }
                         p{
                             color:#F47238;
                         }
                     }
                 }
             }
                 .btn{
                     width:179px;
                     height:39px;
                     border:1px solid rgba(0,0,0,.4);
                     margin: 0 auto;
                     a{
                         -webkit-tap-highlight-color: rgba(0,0,0,0);
                         white-space: nowrap;
                         width:179px;
                         height:39px;
                         vertical-align: middle;
                         touch-action: manipulation;
                         user-select: none;
                         background-image: none;
                         line-height: 39px;
                         font-size: 14px;
                         border-radius: 0;
                         text-align: center;
                         text-decoration: none;
                         text-transform: uppercase;
                         overflow: hidden;
                         color:black;
                         cursor: pointer;
                         display: block;
                         border: none;
                         position: relative;
                         transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);
                         &::before{
                             display: block;
                             position: absolute;
                             top: 0px;
                             right: 0px;
                             height: 100%;
                             width: 0px;
                             z-index: -1;
                             content: '';
                             color: #000 !important;
                             background:#286AA0;
                             transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1);
                         }
                         &::after{
                             content: "";
                             position: absolute;
                             height: 0%;
                             left: 50%;
                             top: 50%;
                             width: 150%;
                             z-index: -1;
                             -webkit-transition: all 0.75s ease 0s;
                             -moz-transition: all 0.75s ease 0s;
                             -o-transition: all 0.75s ease 0s;
                             transition: all 0.75s ease 0s;
                         }
                         &:hover{
                             color:white;
                             border-color: #286AA0;
                         }
                         &:hover::before{
                             left: 0%;
                             right: auto;
                             width: 100%;
                         }
                         &:hover::after{
                             height: 450%;
                         }
                     }
                 }
         }
     }
  }
    .foot{
      animation-duration: 5s;
    }
  @keyframes transition1 {
    0% {
      transform: translate(-100px,100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px,-100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
        clip-path: polygon(100% 0, 99% 50%, 50% 99%,100% 50%);
        opacity: 0;
    }
    100% {
      clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
        opacity: 1;
    }
  }
  @media screen and (max-width: 1440px){
  .main{
   .about{
       width:90%;
       .ln{
           width:100%;
       }
   }
  }
  }
  @media screen and (max-width: 1000px){
      overflow: hidden;
      .main{
          .about{
              .content{
                  .left,.right
                  {
                      animation: none;
                  };
                  .right{
                      &::after{
                          display: none;
                      }
                  }
              }
          }
          .title{
              p{
                  animation: none;
              }
          }
          .ln{
              .p1{
                  p{
                      animation: none;
                  }
              }
          }
          .about{
              .content{
                  width:100%;
                  flex-direction: column;
                  .left,.right{
                      width:100%;
                      margin-left: 0;
                     position: static;
                  }
                  .left{
                      .t1{
                          p:nth-child(1){
                              font-size: 24px;
                          }
                      }
                  }
              }
              .ln{
                  .allItems{
                      flex-wrap: wrap;
                      .item{
                          width:33%;
                      }
                  }
              }
          }
      }
  }
}
</style>
